import { useTranslation } from 'next-i18next';
import type { FC } from 'react';

import StatusMessageBox from 'components/StatusMessageBox';

const AssignDevicesSuccess: FC = () => {
  const { t } = useTranslation();

  return (
    <StatusMessageBox
      type="success"
      message={t(
        'common:pages.organization_overview.assign_devices_to_member.success',
      )}
    />
  );
};

export default AssignDevicesSuccess;
